var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("vue-modal", {
    attrs: {
      "modal-title": _vm.$t("pages.profile.tabs.personal_data.contact_data"),
      "show-spinner": _vm.isLoading,
      "show-modal": _vm.showModal,
      modalLarge: true,
      "loading-primary-footer-button": _vm.isLoading,
      showSecondaryFooterButton: false,
    },
    on: _vm._d({}, [
      _vm.primaryEvent,
      _vm.onPrimaryButtonClicked,
      _vm.closeEvent,
      _vm.onCloseButtonClicked,
    ]),
    scopedSlots: _vm._u([
      {
        key: "body",
        fn: function () {
          return [
            _c("div", { staticClass: "profile" }, [
              _c("article", [
                _vm.error
                  ? _c(
                      "div",
                      {
                        staticClass: "alert alert-danger",
                        attrs: { role: "alert" },
                      },
                      [_vm._v(" " + _vm._s(_vm.error) + " ")]
                    )
                  : _vm._e(),
                _c("form", [
                  _c("div", { staticClass: "row" }, [
                    _c(
                      "div",
                      { staticClass: "col-md-6" },
                      [
                        _vm.canEditAddress
                          ? _c("employee-address-field", {
                              attrs: {
                                id: "edit-employee-address",
                                name: "address",
                                form: _vm.form,
                              },
                            })
                          : _vm._e(),
                        _vm.canEditAddress2
                          ? _c("employee-address-2-field", {
                              attrs: {
                                id: "edit-employee-address2",
                                name: "address2",
                                form: _vm.form,
                              },
                            })
                          : _vm._e(),
                      ],
                      1
                    ),
                    _c(
                      "div",
                      { staticClass: "col-md-6" },
                      [
                        _vm.canEditPersonalPhone
                          ? _c("employee-private-phone-field", {
                              attrs: {
                                id: "edit-employee-private-phone",
                                name: "mobilePhoneNo",
                                form: _vm.form,
                              },
                            })
                          : _vm._e(),
                        _vm.canEditPhoneExt
                          ? _c("employee-extension-field", {
                              attrs: {
                                id: "edit-employee-extension",
                                name: "extension",
                                form: _vm.form,
                              },
                            })
                          : _vm._e(),
                        _vm.canEditPersonalEmail
                          ? _c("employee-private-email-field", {
                              attrs: {
                                id: "edit-employee-private-email",
                                name: "email",
                                form: _vm.form,
                              },
                            })
                          : _vm._e(),
                      ],
                      1
                    ),
                  ]),
                ]),
              ]),
            ]),
          ]
        },
        proxy: true,
      },
    ]),
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }